// This icon file is generated automatically.
var PVerticalAlignBottomOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.44 10.19H.56a.13.13 0 00-.12.12v.94c0 .07.05.13.12.13h10.88c.07 0 .12-.06.12-.13v-.94a.13.13 0 00-.12-.12zM5.9 8.45c.05.07.15.07.2 0l1.75-2.21c.06-.08 0-.2-.1-.2H6.59V.75a.13.13 0 00-.12-.13h-.94a.13.13 0 00-.13.13v5.29H4.25c-.1 0-.16.12-.1.2L5.9 8.45z", "fill-rule": "nonzero" } }] }, "name": "p-vertical-align-bottom", "theme": "outlined" };
export default PVerticalAlignBottomOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PVerticalAlignBottomOutlined.js
// module id = 3716
// module chunks = 0